import { useMemo } from "react";
import TspApiService from "../../api/tspApiService";
import useTspApiResource from "../../hooks/useTspApiResource";

// The API's form options -> what the Add Journey form renders. Ids become
// strings (they are <select> values). A journey is created without a team, so
// the states are used (the leader is searched as it is typed), and `temples` —
// the signed-in user's own, from their ICC account — supply its temple.
export function adaptFormOptions(options) {
  return {
    breadcrumb: ["Dashboard", "Journeys", "Add Journey"],
    states: (options.states || []).map((state) => ({ id: String(state.id), name: state.name })),
    temples: (options.temples || []).filter((temple) => typeof temple === "string" && temple.trim()),
  };
}

// The states — from the API, never a built-in list.
export default function useTspAddJourneyData() {
  const resource = useTspApiResource(() => Promise.resolve(TspApiService.getJourneyFormOptions?.() || { data: { states: [], temples: [] } }), []);
  const data = useMemo(() => (resource.data ? adaptFormOptions(resource.data) : null), [resource.data]);
  return { data, loading: resource.loading && !resource.data, error: resource.error, reload: resource.reload };
}
